import styled from 'styled-components'
import { SearchButton } from '../generic/SearchButton'
import Filter from '../filter/Filter'
import MonthFilter from './MonthFilter'

const SearchRow = styled.div`
    --layout-gutter-x: 1.5rem;
    --layout-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    width: 100%;
    align-items: center;
    column-gap: 0.5rem;

    & >* {
      flex-shrink: 0;
      margin-top: var(--layout-gutter-y);
      padding-block: ${({ $paddingBlock }) => $paddingBlock};
    }
`

const SearchRowCol = styled.div`
    display: flex;
    padding: ${({ $padding }) => $padding};
    @media (min-width: 576px) {
      flex: ${({ $flex }) => $flex};
    }
`

// The month filter follows the other filters; the far right of the top bar
// belongs to the list's actions.
const MonthCol = styled(SearchRowCol)`
    align-items: center;
`

// The list's other pickers — group filters, a connect filter — follow search.
const ExtrasCol = styled(SearchRowCol)`
    align-items: center;
    gap: 0.5rem;
`

const ViewTableToolbar = ({
  searchTerm,
  setSearchTerm,
  table,
  config,
  userFilterLabel,
  onApplyLocationFilter,
  onClearFilter,
  monthFilter,
  onMonthFilterChange,
  extras, // pickers the list adds after search: group filters, a connect filter
}) => {
  return (
    <SearchRow>
      <SearchRowCol name='Col'>
        <SearchButton
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchLabel={table.searchLabel}
          searchPlaceholder={searchTerm || table.searchPlaceholder}
          testId={`${config.entity}.list.search`}
        />
      </SearchRowCol>
      {table?.filter?.type === 'location' && (
        <SearchRowCol>
          <Filter
            config={table.filter}
            selectedLabel={userFilterLabel}
            onApply={onApplyLocationFilter}
            onClear={onClearFilter}
          />
        </SearchRowCol>
      )}
      {extras && <ExtrasCol>{extras}</ExtrasCol>}
      {monthFilter && (
        <MonthCol>
          <MonthFilter
            value={monthFilter.value}
            onChange={onMonthFilterChange}
            testId={`${config.entity}.list.month`}
          />
        </MonthCol>
      )}
    </SearchRow>
  )
}

export default ViewTableToolbar
